module.exports = __webpack_public_path__ + "static/media/CyclonX-RC-4300.6c53f17d.png";